import { useNavigate } from "react-router-dom";

const CategoryHero = ({ category }) => {
    const navigate = useNavigate();

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-10 pt-28 mt-6">
            {/* Breadcrumbs */}
            <div className="mb-8">
                <nav className="flex items-center text-sm text-gray-500 whitespace-nowrap overflow-x-auto">
                    <span className="cursor-pointer hover:text-blue-600 transition-colors font-medium" onClick={() => navigate("/")}>Home</span>
                    <span className="mx-2.5 text-gray-400 select-none">/</span>
                    <span className="cursor-pointer hover:text-blue-600 transition-colors font-medium" onClick={() => navigate("/categories")}>Categories</span>
                    <span className="mx-2.5 text-gray-400 select-none">/</span>
                    <span className="text-gray-900 font-semibold">{category?.categoryName}</span>
                </nav>
            </div>
            
            <div>
                <div className="flex flex-col lg:flex-row gap-12 items-center">
                    {/* Left text column */}
                    <div className="lg:w-7/12 space-y-6">
                        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-100 uppercase tracking-wider">
                            Learning Pathway
                        </span>
                        
                        <h1 className="text-4xl md:text-5xl font-extrabold text-gray-950 tracking-tight leading-none">
                            {category?.categoryName}
                        </h1>
                        
                        <p className="text-lg text-gray-600 leading-relaxed font-normal">
                            {category?.categoryDescription?.replace(/<[^>]+>/g, "") || "Explore professional courses and certifications curated to help you build in-demand industry skills."}
                        </p>

                        <div className="flex flex-wrap gap-4 pt-2">
                            <div className="flex items-center gap-2 text-sm text-gray-600 bg-gray-50 border border-gray-100 rounded-lg px-3 py-1.5 font-medium animate-fadeIn">
                                <span className="w-2.5 h-2.5 rounded-full bg-green-500 animate-pulse"></span>
                                Live Online Sessions
                            </div>
                            <div className="flex items-center gap-2 text-sm text-gray-600 bg-gray-50 border border-gray-100 rounded-lg px-3 py-1.5 font-medium">
                                🎓 Industry Certified
                            </div>
                        </div>
                    </div>

                    {/* Right media preview column */}
                    <div className="w-full lg:w-5/12">
                        <div className="relative rounded-2xl overflow-hidden bg-gradient-to-tr from-blue-900 via-indigo-950 to-slate-900 p-1 shadow-2xl group">
                            {/* Abstract Geometric CSS cover */}
                            <div className="w-full rounded-2xl h-[280px] sm:h-[320px] md:h-[350px] overflow-hidden relative flex flex-col justify-between p-6 select-none bg-gradient-to-br from-blue-700/40 via-indigo-900/50 to-black/80">
                                {/* Geometric grid shapes */}
                                {/* <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:24px_24px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]"></div> */}
                                {/* <div className="absolute -left-16 -top-16 w-48 h-48 rounded-full bg-blue-600/30 blur-3xl"></div> */}
                                {/* <div className="absolute right-0 bottom-0 w-64 h-64 rounded-full bg-indigo-600/20 blur-3xl"></div> */}

                                {/* Top card tag */}
                                <div className="z-10 self-start bg-white/10 backdrop-blur-md border border-white/20 px-3 py-1 rounded-full text-xs font-semibold text-white tracking-wide">
                                    yslearn Pathways
                                </div>

                                {/* Main visual area */}
                                <div className="z-10 flex flex-col justify-center items-center py-6 text-center space-y-3">
                                    <div className="w-16 h-16 rounded-2xl bg-blue-600/90 text-white flex items-center justify-center text-3xl font-bold shadow-lg border border-blue-400/30">
                                        {category?.categoryName?.substring(0, 2)?.toUpperCase() || "SL"}
                                    </div>
                                    <span className="text-xl font-bold tracking-tight text-white block">
                                        {category?.categoryName}
                                    </span>
                                    <span className="text-xs text-blue-200 block uppercase tracking-widest font-medium">
                                        Build Skills • Earn Badges • Advance Career
                                    </span>
                                </div>

                                {/* Bottom card footer */}
                                <div className="z-10 flex items-center justify-between text-xs text-gray-300 border-t border-white/10 pt-4">
                                    <span>Interactive Syllabus</span>
                                    <span>Live Support 24/7</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CategoryHero;